import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonFormGrid } from 'components/common/form/grid';
import { CommonTextInput } from 'components/common/form/text';
import { RegexFilter } from 'interfaces/forms/text';
import { useState } from 'react';

export const FeatureDemoTextfields = () => {
  const [alpha, setAlpha] = useState('');
  const [alphaNum, setAlphaNum] = useState('');
  const [whitespace, setWhitespace] = useState('');

  return (
    <ErrorBoundary identifier="FeatureDemoTextfields">
      <CommonFormGrid columns={3}>
        <CommonTextInput
          id="demo-alpha"
          label="Alpha"
          value={alpha}
          regex={RegexFilter.Alpha}
          onChange={(v) => setAlpha(v ?? '')}
        />
        <CommonTextInput
          id="demo-alpha-num"
          label="AlphaNumeric"
          value={alphaNum}
          regex={RegexFilter.AlphaNumeric}
          onChange={(v) => setAlphaNum(v ?? '')}
        />
        <CommonTextInput
          id="demo-whitespace"
          label="Whitespace"
          value={whitespace}
          regex={RegexFilter.Whitespace}
          onChange={(v) => setWhitespace(v ?? '')}
        />
      </CommonFormGrid>
    </ErrorBoundary>
  );
};
